import { ActionTypesFactory } from '../../../../../utils/utils';

export const CreateBankDetailsActionTypes = ActionTypesFactory('BankClients', 'create_bankdetails');
export const DeleteBankDetailsActionTypes = ActionTypesFactory('BankClients', 'delete_bankdetails');
export const GetBankDetailsActionTypes = ActionTypesFactory('BankClients', 'Get_BankDetails');
export const EditBankDetailsActionTypes = ActionTypesFactory('BankClients', 'Edit_BankDetails');
